import * as React from 'react';

const Down = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M6.99951 9.5L11.9995 14.5L16.9995 9.5H6.99951Z'
      fill='#D1D1D1'
    />
  </svg>
);
export default Down;
